import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

const MultiValueRemove = props => {
  const {
    data: { value: propsValue },
    selectProps: {
      input: { name }
    }
  } = props;
  const value = typeof propsValue === 'string' ? propsValue.split(' ').join('-') : '';
  return (
    <div data-desc={`select__${name}_option_${value}_remove`}>
      <components.MultiValueRemove {...props} />
    </div>
  );
};

MultiValueRemove.propTypes = {
  selectProps: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default MultiValueRemove;
